import {
  extendVariants,
  Button as NextButton,
  ButtonProps as _ButtonProps,
} from '@nextui-org/react';
import { forwardRef } from 'react';
import { TestIdMixin } from '../types';

export interface ButtonProps extends _ButtonProps, TestIdMixin {}

const Component = extendVariants(NextButton, {
  variants: {
    size: {
      sm: 'h-[36px] min-h-[36px] text-sm font-bold',
      md: 'h-[44px] min-h-[44px] text-sm sm:text-md font-bold',
      lg: 'h-[52px] min-h-[52px] text-md sm:text-lg font-bold',
    },
    color: {
      primary: 'bg-primary',
      secondary: 'bg-secondary/60',
    },
    variant: {
      bordered: 'border-2 border-navy bg-transparent text-navy',
    },
  },
  defaultVariants: {
    size: 'lg',
    radius: 'sm',
  },
});

export const Button = forwardRef<HTMLButtonElement | null, ButtonProps>(
  (props, ref) => <Component ref={ref} {...props} />
);
